parasails.registerPage('tournament', {
  //  ╦╔╗╔╦╔╦╗╦╔═╗╦    ╔═╗╔╦╗╔═╗╔╦╗╔═╗
  //  ║║║║║ ║ ║╠═╣║    ╚═╗ ║ ╠═╣ ║ ║╣
  //  ╩╝╚╝╩ ╩ ╩╩ ╩╩═╝  ╚═╝ ╩ ╩ ╩ ╩ ╚═╝
  data: {
    eventID: '',
    overallEventID: '',
    deviceidentifier: '',
    currentVoteData: {},
    eventLogo: 'images/caramel-logo.png',
    listenerID: '',
    eventIsLive: false,
    stageindex: -1,
    contestantOne: 'Contestant One',
    contestantTwo: 'Contestant Two',
    contestantOneIndex: -1,
    contestantTwoIndex: -1,
    selectedContestantIndex: -1,
    selectedContestantName: '', //Convenience for use in data
    locationIndex: -1,
    currentpage: 0,
    buttonClassA: 'btn-voteStart',
    buttonClassB: 'btn-voteSecond',
  },

  //  ╦  ╦╔═╗╔═╗╔═╗╦ ╦╔═╗╦  ╔═╗
  //  ║  ║╠╣ ║╣ ║  ╚╦╝║  ║  ║╣
  //  ╩═╝╩╚  ╚═╝╚═╝ ╩ ╚═╝╩═╝╚═╝
  beforeMount: function() {
    //…
  },
  mounted: async function() {
    this.eventID = this.eventData.id;
    this.listenerID = this.eventData.overallEventID;
    this.eventIsLive = this.eventData.isLive;
    this.currentVoteData.voted = false;
    this.locationIndex = this.eventData.isViewerLocal;
    this.setLogo();
    this.deviceidentifier = this.eventData.deviceidentifier;
    if(this.eventData.TournamentData) {
      this.stageindex = (this.eventData.TournamentData.currentRound) ? this.eventData.TournamentData.currentRound : -1;
      this.currentpage = (this.eventData.TournamentData.currentpage) ? this.eventData.TournamentData.currentpage : 0;
      if(this.currentpage === 1) {
        this.contestantOne = this.eventData.TournamentData.currentContestantOneName;
        this.contestantTwo = this.eventData.TournamentData.currentContestantTwoName;
        this.contestantOneIndex = this.eventData.TournamentData.contestantOneIndex;
        this.contestantTwoIndex = this.eventData.TournamentData.contestantTwoIndex;

        //Check if this device already voted. If it did, set the page to 2.
        if(this.eventData.voteData) {
          for(var i = 0; i < this.eventData.voteData.length; i++) {
            if(this.eventData.voteData[i].stageindex === this.stageindex) {
              this.selectedContestantName = this.eventData.voteData[i].contestantName;
              this.currentpage = 2;
              break;
            }
          }
        }
      }
    } else {
      console.log('Did not find any data for this tournamnet.');
    }

    io.socket.on(this.eventData.id, (params) => {
      console.log('Received socket message: ' + params.eventType);
      switch(params.eventType) {
        case 'tvote': console.log('vote sent'); break;
        case 'show_welcome':
          this.currentpage = 0;
          break;
        case 'show_welcome_local':
          // eslint-disable-next-line eqeqeq
          if(this.locationIndex == 0) this.currentpage = 0;
          break;
        case 'show_welcome_remote':
          // eslint-disable-next-line eqeqeq
          if(this.locationIndex == 1) {this.currentpage = 0;}
          break;
        case 'show_vote':
          this.currentVoteData.voted = false;
          this.currentpage = 1;
          this.selectedContestantIndex = -1;
          this.selectedContestantName = '';
          this.stageindex = params.stageIndex;
          this.contestantOne = params.contestantOne;
          this.contestantTwo = params.contestantTwo;
          this.contestantOneIndex = params.contestantOneIndex;
          this.contestantTwoIndex = params.contestantTwoIndex;
          break;
        case 'show_vote_local':
          // eslint-disable-next-line eqeqeq
          if(this.locationIndex == 0) {
            this.currentVoteData.voted = false;
            this.currentpage = 1;
            this.selectedContestantIndex = -1;
            this.selectedContestantName = '';
            this.stageindex = params.stageIndex;
            this.contestantOne = params.contestantOne;
            this.contestantTwo = params.contestantTwo;
            this.contestantOneIndex = params.contestantOneIndex;
            this.contestantTwoIndex = params.contestantTwoIndex;
          }
          break;
        case 'show_vote_remote':
          // eslint-disable-next-line eqeqeq
          if(this.locationIndex == 1) {
            this.currentVoteData.voted = false;
            this.currentpage = 1;
            this.selectedContestantIndex = -1;
            this.selectedContestantName = '';
            this.stageindex = params.stageIndex;
            this.contestantOne = params.contestantOne;
            this.contestantTwo = params.contestantTwo;
            this.contestantOneIndex = params.contestantOneIndex;
            this.contestantTwoIndex = params.contestantTwoIndex;
          }
          break;
        // default: console.log('UNEXPECTED SOCKET MESSAGE: ' + JSON.stringify(params));
      }
    });

    // This is a test and may not work
    io.socket.on('disconnect', function onDisconnect(){
      console.log('This socket lost connection to the visibby server');
      io.socket.reconnect();
    });
  },

  //  ╦╔╗╔╔╦╗╔═╗╦═╗╔═╗╔═╗╔╦╗╦╔═╗╔╗╔╔═╗
  //  ║║║║ ║ ║╣ ╠╦╝╠═╣║   ║ ║║ ║║║║╚═╗
  //  ╩╝╚╝ ╩ ╚═╝╩╚═╩ ╩╚═╝ ╩ ╩╚═╝╝╚╝╚═╝
  methods: {
    //…
    voted: function() {
      this.currentVoteData.voted = true;
      this.showVoteConfirmation = true;
      this.currentpage = 2;
    },
    setLogo() {
      if(this.eventData.logoImage) {
        this.eventLogo = this.eventData.logoImage;
      }
    }
  }
});
